import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function PlanToolbar({ search, chips, zoomOpts, saveState, onSearch, onToggleChip, onSetZoom, }) {
    return (_jsxs("div", { style: {
            flex: 'none',
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            padding: '7px 12px',
            background: '#FFFFFF',
            borderBottom: '1px solid #E2E8F0',
            flexWrap: 'wrap',
        }, children: [_jsx("input", { value: search, onChange: (e) => onSearch(e.target.value), placeholder: "\u041F\u043E\u0438\u0441\u043A \u043F\u043E \u043F\u0440\u043E\u0435\u043A\u0442\u0430\u043C", className: "kp-search", style: {
                    width: 220,
                    height: 30,
                    border: '1px solid #E2E8F0',
                    borderRadius: 8,
                    padding: '0 10px',
                    fontSize: 12.5,
                    background: '#F8FAFC',
                } }), _jsx("div", { style: { display: 'flex', gap: 6 }, children: chips.map((c) => (_jsx("button", { type: "button", onClick: () => onToggleChip(c.key), className: "kp-chip", style: {
                        height: 26,
                        padding: '0 10px',
                        borderRadius: 999,
                        fontSize: 11.5,
                        fontWeight: 600,
                        cursor: 'pointer',
                        border: `1px solid ${c.bd}`,
                        background: c.bg,
                        color: c.color,
                    }, children: c.label }, c.key))) }), _jsx("div", { style: { flex: 1 } }), _jsx("div", { style: { display: 'flex', border: '1px solid #E2E8F0', borderRadius: 8, overflow: 'hidden' }, children: zoomOpts.map((z) => (_jsx("button", { type: "button", onClick: () => onSetZoom(z.key), style: {
                        height: 28,
                        padding: '0 10px',
                        border: 'none',
                        fontSize: 11.5,
                        fontWeight: 600,
                        cursor: 'pointer',
                        background: z.bg,
                        color: z.color,
                    }, children: z.label }, z.key))) }), _jsxs("div", { style: { display: 'flex', alignItems: 'center', gap: 6, minWidth: 106, justifyContent: 'flex-end' }, children: [saveState === 'saved' ? (_jsx("span", { style: { width: 7, height: 7, borderRadius: '50%', background: '#22C55E' } })) : (_jsx("span", { style: {
                            width: 11,
                            height: 11,
                            border: '2px solid #CBD5E1',
                            borderTopColor: '#2563EB',
                            borderRadius: '50%',
                            animation: 'kp-spin .7s linear infinite',
                        } })), _jsx("span", { style: { fontSize: 11.5, color: '#64748B' }, children: saveState === 'saving' ? 'Сохранение…' : 'Сохранено' })] })] }));
}
